export default {
  setUploads(state, data) {
    state.uploads = data;
  },
  setUpload(state, data) {
    state.upload = data;
  },
  setExcelTemplateHtml(state, data) {
    state.excelTemplateHtml = data;
  },
};
